<script lang="ts">
    import {PlanDetails} from "../../models/PlanDetails";
    import{ convertToCurrency} from "../../services/Utilities";
    export let planDetails: PlanDetails = new PlanDetails();

</script>

<div class="plan-details-component info-section">
   <div class="edit-section">
          <h2>Plan Details</h2>
   </div>
    <hr/>

    <div class="text-section">
        <div class="text-row">
            <div class="text-group">
                <div class="content-text-label">Policy Number:</div>
                <div class="bold-text">{planDetails.policyNumber}</div>
            </div>
            <div class="text-group">
                <div class="content-text-label">Risk Class:</div>
                <div class="bold-text">{planDetails.riskClass}</div>
            </div>
        </div>
           <div class="text-row">
                    <div class="text-group">
                        <div class="content-text-label">Face Amount:</div>
                        <div class="bold-text">{convertToCurrency(planDetails.faceAmount)}</div>
                    </div>
                    <div class="text-group">
                        <div class="content-text-label">Premium:</div>
                        <div class="bold-text">{convertToCurrency(planDetails.premium)}</div>
                    </div>
                </div>
        <div class="text-row">
            <div class="text-group">
                <div class="content-text-label">Plan Name:</div>
                <div class="bold-text">{planDetails.planName}</div>
            </div>
            <div class="text-group">
                <div class="content-text-label">Pay Mode:</div>
                <div class="bold-text">{planDetails.payMode}</div>
            </div>
        </div>

    </div>



</div>

<style lang="scss">
  @use "../../../component_scss_library/layout" as layout;
  @use "../../../component_scss_library/buttons" as buttons;
  @use "../../../component_scss_library/forms" as forms;
</style>
